module.exports = __webpack_public_path__ + "img/menu-5-points.dd0b9dda.jpg";